import { Route, Routes } from 'react-router-dom';
import { SynchronizationSummaryPage } from './SynchronizationSummaryPage';
import { ExternalProductMatchingPage } from './ExternalProductMatchingPage';

export const SynchronizationSummaryPageRoot = () => (
  <Routes>
    <Route path='/:platform' element={<ExternalProductMatchingPage />} />
    <Route path='*' element={<SynchronizationSummaryPage />} />
  </Routes>
);
